import { RefundKindEnum } from '../../../generated/api.graphql';

export const RefundKind = Object.freeze({
  PARTIAL: RefundKindEnum.Partial,
  FULL: RefundKindEnum.Full,
});
export type RefundKind = (typeof RefundKind)[keyof typeof RefundKind];
